'use client';

import { useDevice } from '@/app/lib/contexts/DeviceContext';
import { useNavbar } from '@/app/lib/contexts/NavbarContext';
import LandscapeSideNav from './desktop/landscape-side-nav';
import MobileBottomNav from './mobile/mobile-bottom-nav';

export default function ResponsiveNavbar() {
  const { isMobile, isDesktop } = useDevice();
  const { isNavbarHidden } = useNavbar();

  // Don't render anything until device detection is complete
  if (!isMobile && !isDesktop) {
    return null;
  }

  // Don't render navbar if it's explicitly hidden
  if (isNavbarHidden) {
    return null;
  }

  return (
    <>
      {isDesktop && <LandscapeSideNav />}
      {isMobile && <MobileBottomNav />}
    </>
  );
} 